import React, { Component } from "react";
import axios from "axios";

import {
  VideoCount,
  GridContainer,
  PaginationContainer,
} from "../MyVideo.style";
import ShortsCard from "../../Common/Card/ShortsCard";
import ShortsCardFooter from "@/UserPage/Common/MyVideoCardFooter/ShortsCardFooter";
import ShortsDialog from "../../Common/VideoDialog/ShortsDialog";
import ConfirmationDialog from "../../Common/ConfirmationDialog/ConfirmationDialog";
import { Pagination2 } from "../../Common/Pagination2/Pagination2";
import { EmptyLayerIcon } from "../../Common/SvgIcon/EmptyLayerIcon";
import { FinishedLayerIcon } from "../../Common/SvgIcon/FinishedLayerIcon";
import { GetBaseUrl, GetOriginalBaseUrl } from '@/utils/ConfigHelper'
import Loading from '@/Common/loading/loading'
import EmptyVideo from "../emptyVideo/emptyVideo";
import UploadCompleted from '@/Common/UploadCompleted/UploadCompleted'
import OneBtnDialog from "@/Common/OneBtnDialog/OneBtnDialog";
import i18n from '@/i18n';
import ChangeTitleInput from '../ChangeTitleInput/ChangeTitleInput';
import ShareDialog from "../ShareDialog/ShareDialog";
import TwoBtnDialog from "@/Common/TwoBtnDialog/TwoBtnDialog";
import Uploading from '@/Common/Uploading/Uploading'
import TemplateHelper from '@/utils/TemplateHelper'
import { SHORTS_RENDER_STATE, ROUTE_PATH } from "@/utils/Global";
import DataManager from "@/utils/DataManager";
import { connect } from 'react-redux'
import { Trans } from 'react-i18next'
import Validator from "@/utils/Validator";
import TokenHelper from "@/utils/DataManager/TokenHelper";
import ShortsApis from "@/utils/Videomonster/Apis/Shorts";

const formatDate = videoDate => {
  const date = new Date(videoDate);
  const dateString = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .split("T")[0];
  const finalDate = dateString.replace(/-/g, ".");
  return finalDate;
};

class ShortsPage extends Component {

  _isMounted = false

  state = {
    isDialogOpened: false,
    focusedDialogName: "",
    isBtnDialogOpened: false,
    dialogType: "failEditVideo",
    selectedVideoId: null,
    currentPage: 0,
    cardsPerPage: 15,
    myVideos: undefined,
    isNoPayment: true,
    userRemoveTemplate: false,

    renderingVideos: {},
    isOpenSettingDropdown: false,
    isChangeTitleInputDialog: false,
    videoId: "",
    title: "",
    isShareDialogOpen: false,
    selectedVideo: {},
    isOpenPayTwoButton: false,

    isUploading: false,
    totalVideos: 0
  };
  provider = DataManager.GetProvider()

  getMyvideo = async () => {
    const { currentPage, cardsPerPage } = this.state;

    const offset = currentPage;
    const limit = cardsPerPage;

    const { result, data } = await ShortsApis.GetShortsList(TokenHelper.GetToken(), {
      offset,
      limit
    })
    if (!result) return;

    const myVideos = data.list;
    const totalVideos = data.count;

    this.setState({
      myVideos: myVideos,
      totalVideos: totalVideos
    })

    if (Array.isArray(myVideos)) {
      myVideos.forEach(item => {
        if (item.state === SHORTS_RENDER_STATE.WAITING) {
          setTimeout(() => {
            this.refreshVideoState(item._id)
          }, 5000)
        }
      })

      this.beginReqRenderProgress();
      if (this.renderingProgressTimer) clearInterval(this.renderingProgressTimer);
      this.renderingProgressTimer = setInterval(this.beginReqRenderProgress, 5000);
    }
  }

  componentDidMount() {
    if (!this.props.isMounted) return
    this.getMyvideo()
    this._isMounted = true
  }

  componentWillUnmount() {
    if (this.renderingProgressTimer) clearInterval(this.renderingProgressTimer);
    this._isMounted = false
  }
  //렌더링 시작시작이 2시간이 지났는지 확인 
  getIsRenderOverTime(startDate) {
    if (!startDate) return true;
    
    const renderStrDate = new Date(startDate)
    const nowDate = new Date();
    const isOvertime = ((nowDate - renderStrDate) / 1000) >= (60 * 60 * 2)
    return isOvertime;
  }

  renderingProgressTimer
  beginReqRenderProgress = async () => {
    const { myVideos } = this.state
    if (!myVideos) return
    const token = TokenHelper.GetToken()

    const renderVideos = {}
    myVideos.forEach(item => {
      if (item.state === SHORTS_RENDER_STATE.RENDERING) {
        if (!this.getIsRenderOverTime(item.setStateDate)) renderVideos[item._id] = { region: item.region || 'KR' }
      }
    })

    if (Object.keys(renderVideos).length === 0) //렌더중인 비디오가 없다면 타이머 삭제
    {
      if (this.renderingProgressTimer) clearInterval(this.renderingProgressTimer);
      return;
    }

    for (var key in renderVideos) {
      try {
        const { result, data } = await ShortsApis.GetShortsItem(token, { shortsId: key })
        if (data && data.item) {
          if (data.item.state !== SHORTS_RENDER_STATE.RENDERING && data.item.state !== SHORTS_RENDER_STATE.WAITING) {
            this.refreshVideoState(key)
            continue;
          }
        }
  
        renderVideos[key] = { ...data };
      }
      catch (err) {
        
      }
    }

    this.setState({ renderingVideos: renderVideos });
  }

  refreshVideoState = async id => {
    if (!this._isMounted) return

    try {
      const { result, data } = await ShortsApis.GetShortsItem(TokenHelper.GetToken(), { shortsId: id });
      if (!result || !data) return;
  
      const { myVideos } = this.state
      let { selectedVideo } = this.state
      if (!myVideos) return

      let waitingFlag = false
      let renderingFlag = false

      for (let i = 0; i < myVideos.length; i++) {
        if (myVideos[i]._id === id) {
          if (data.item.state === SHORTS_RENDER_STATE.WAITING) {
            waitingFlag = true
          }
          if (data.item.state === SHORTS_RENDER_STATE.RENDERING) {
            renderingFlag = true
            // TODO :: 추후에 렌더링 오랫동안 안끝나면 Error 상태 처리 필요
            // if (data.item.setStateDate && this.getIsRenderOverTime(data.item.setStateDate)) {
            //   data.item.state = "Error"
            // }
          }
          if (data.item.thumbnailURL) data.item.thumbnailURL = `${data.item.thumbnailURL}?${new Date().getTime()}`
          myVideos[i] = {
            ...myVideos[i],
            ...data.item,
          }

          if (selectedVideo && selectedVideo._id === id) {
            selectedVideo = { ...selectedVideo, ...data.item }
            this.setState({ selectedVideo: { ...selectedVideo } })
          }
          break
        }
      }
      this.setState({ myVideos }, () => {
        if (waitingFlag) {
          setTimeout(() => {
            this.refreshVideoState(id)
          }, 5000)
        }
        if (renderingFlag) {
          if (this.renderingProgressTimer) clearInterval(this.renderingProgressTimer);
          this.renderingProgressTimer = setInterval(this.beginReqRenderProgress, 5000);
        }
      })
    }
    catch (e) {

    }
  }

  openDialog = (focusedDialogName, videoId, layered) => event => {
    if (!layered || layered.state === SHORTS_RENDER_STATE.RENDERING || layered.state === SHORTS_RENDER_STATE.WAITING) {
      return;
    }

    this.setState({
      isDialogOpened: true,
      focusedDialogName,
      selectedVideoId: videoId || null
    });
  };
  closeDialog = () => {
    this.setState({ isDialogOpened: false, focusedDialogName: "" });
  };
  onThumbnailClicked = (videoId, analysisId, analysisIndex, layered, isEditable, isStoreExpired) => async event => {
    if (!layered) {
      this.openDialog("ShortsDialog", videoId, layered);
      return;
    }

    if (layered.state === SHORTS_RENDER_STATE.EMPTY) {
      this._onVideoEditClicked(videoId, analysisId, analysisIndex, layered, isEditable, isStoreExpired)
      return;
    }

    if (layered.state === SHORTS_RENDER_STATE.WAITING || layered.state === SHORTS_RENDER_STATE.RENDERING) {
      return;
    }

    // 이건 계정 정지 시 다운로드 막는거 (false이면 정지, undefined면 아직 서버 통신 안된거)
    if (this.props.accountStatus.isDownloadable === undefined) {
      return
    }

    if (this.props.accountStatus.isDownloadable === false) {
      return alert(i18n.t("myvideo.alert.block.download.id"))
    }

    this.setState({
      isDialogOpened: true,
      focusedDialogName: "ShortsDialog",
      selectedVideoId: videoId,
      isNoPayment: false
    });
  };

  openFailMoveEditVideoPage = () => {
    this.setState({
      isBtnDialogOpened: true,
      dialogType: "failMoveEditVideoPage"
    })
  }

  getSelectedVideo = (videoId) => {
    const { myVideos } = this.state
    if (!myVideos || myVideos.length === 0) return null

    const selectedVideo = myVideos.filter(video => video._id === videoId)[0]
    return selectedVideo
  }

  onVideoEditClicked = (videoId, analysisId, analysisIndex, layered, isEditable, isStoreExpired) => event => {
    this._onVideoEditClicked(videoId, analysisId, analysisIndex, layered, isEditable, isStoreExpired)
  }

  _onVideoEditClicked = async (videoId, analysisId, analysisIndex, layered, isEditable, isStoreExpired = true) => {
    if (isStoreExpired) return
  
    if (!analysisId || analysisId === '') return alert(i18n.t("VideoDialog.renderVideo.error"))

    if (!layered || layered.state === SHORTS_RENDER_STATE.WAITING || layered.state === SHORTS_RENDER_STATE.RENDERING) {
      return;
    }
    this.setState({ selectedVideoId: videoId })

    if (!isEditable)  return this.handlePayDialogOpen()

    const { result, data } = await ShortsApis.GetShortsAnalysisMetadata(TokenHelper.GetToken(), { analysisId })
    if (result && data &&
      data.metadataJsonUrl &&
      data.videoUrl &&
      data.audioUrl &&
      data.previewImageUrl &&
      data.inputData &&
      data.outputData
    ) {
      const { analyzedDataUrls, sttDataUrl, allSplitDataUrl } = data.outputData
      const { layout: layoutType } = data.inputData
      if (!Array.isArray(analyzedDataUrls) || analyzedDataUrls.length === 0) return;
      const analysisResults = await Promise.all(analyzedDataUrls.map(async (url) => {
        const { data } = await axios.get(url)
        return data
      }))

      let allSentencesResponse;
      let metadataResponse;
      if (allSplitDataUrl) {
        const [{ data: allSplitSentencesData }, { data: metadataData }] = await Promise.all([
          axios.get(allSplitDataUrl),
          axios.get(data.metadataJsonUrl)
        ])
        allSentencesResponse = allSplitSentencesData.sentences
        metadataResponse = metadataData
      }
      else {
        const [{ data: allSentencesData }, { data: metadataData }] = await Promise.all([
          axios.get(sttDataUrl),
          axios.get(data.metadataJsonUrl)
        ])
        allSentencesResponse = allSentencesData
        metadataResponse = metadataData
      }

      const initData = {
        layout: layoutType,
        topic: analysisResults[analysisIndex].splitTopic,
        sentences: analysisResults[analysisIndex].splitSentences.map(sentence => ({
          ...sentence,
          start: sentence.start / 1000,
          end: sentence.end / 1000,
          duration: sentence.duration / 1000
        })),
        allSentences: allSentencesResponse.map(sentence => ({
          ...sentence,
          start: sentence.start / 1000,
          end: sentence.end / 1000,
          duration: sentence.duration / 1000
        })),
      }

      this.props.history.push(ROUTE_PATH.SHORTS_CUSTOMIZING, {
        index: analysisIndex,
        shortsId: videoId,
        metadataJson: metadataResponse,
        videoUrl: data.videoUrl,
        audioUrl: data.audioUrl,
        previewImageUrl: data.previewImageUrl,
        initData
      })
    }
    else {
      alert(i18n.t("VideoDialog.renderVideo.error"))
    }
  };

  handleAlertDialogOpen=(dialogType)=>{
    this.setState({ dialogType, isBtnDialogOpened: true });
  }

  onDownloadClicked = async (videoId, videoName, isDownloadable, layered) => {
    const { myVideos } = this.state
    if (!myVideos) return;

    // 이건 계정 정지 시 다운로드 막는거 (false이면 정지, undefined면 아직 서버 통신 안된거)
    if (this.props.accountStatus.isDownloadable === undefined) {
      return
    }

    if (this.props.accountStatus.isDownloadable === false) {
      return alert(i18n.t("myvideo.alert.block.download.id"))
    }

    // if (!isDownloadable) {
    //   return;
    // }

    if (layered) {
      if (layered.state === SHORTS_RENDER_STATE.RENDERING) return
      if (layered.state === SHORTS_RENDER_STATE.WAITING) return
      if (layered.state === SHORTS_RENDER_STATE.ERROR) return
      if (layered.state === SHORTS_RENDER_STATE.EMPTY) return
    }

    const targetVideo = myVideos.find(video => video._id === videoId)
    if (!targetVideo || !targetVideo.url) return;

    const url = targetVideo.url;
    axios.get(`${url}?date=${Date.now().toString()}`, {
      responseType: "blob"
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = `${videoName}.mp4`;
      link.click();
    })
      .catch(e => {
        if (e instanceof Error) {
          const { message, name, stack } = e
          axios.post(`${GetBaseUrl()}/api/system/app-error-log`, {
            id: 'myvideo',
            log: JSON.stringify({
              message,
              name,
              stack
            }),
            deviceInfo: {}
          }).catch(() => { })
        }
      })
  };
  onDeleteClicked = videoId => async event => {
    const { result } = await ShortsApis.DeleteShorts(TokenHelper.GetToken(), {
        shortsId: videoId
    })
    if (result) this.onMyVideoDeleted(videoId);
    this.closeDialog();
  };

  onPageNumberClicked = newPage => event => {
    this.setState({ currentPage: newPage }, () => {
      this.getMyvideo();
    });
  };
  onPreviousPageClicked = newPage => event => {
    this.setState({ currentPage: newPage }, () => {
      this.getMyvideo();
    });
  };
  onNextPageClicked = newPage => event => {
    this.setState({ currentPage: newPage }, () => {
      this.getMyvideo();
    });
  };
  onViewAllFreeVideosButtonClicked = () => {
    const { history } = this.props
    history.push(ROUTE_PATH.YOUTUBE_SHORTS);
  }
  popupHandleCloseBtn = () => {
    this.setState({
      isBtnDialogOpened: false
    })
  }

  onMyVideoDeleted = deletedVideoId => {
    const { myVideos } = this.state

    const targetVideo = myVideos && myVideos.filter(myVideo => myVideo._id === deletedVideoId)
    if (targetVideo.length === myVideos.length && this.state.currentPage > 0) {
      this.onPreviousPageClicked(this.state.currentPage - 1)();
    }
    else {
      this.getMyvideo();
    }
  };
  clickRemoveTemplate = () => () => {
    // this.setState({
    //   userRemoveTemplate: false
    // });
  };
  SettingClick = (id, layered) => {
    if (!layered) {
      return;
    }

    if (layered.state === "Rendering") {
      return;
    }

    if (layered.state === "Waiting") {
      return;
    }

    this.setState({
      isOpenSettingDropdown: !this.state.isOpenSettingDropdown,
      videoId: id
    })
  }
  handleClickAway = () => {
    this.setState({
      isOpenSettingDropdown: false,
    })
  }
  // 제목변경 팝업 열기
  handleChangeTitle = (video) => {
    console.log("handleChangeTitle", video)
    this.setState({ isChangeTitleInputDialog: true, selectedVideo: video })
  }
  // 제목변경 팝업 닫기
  closeChangeTitleInputDialog = () => {
    this.setState({ isChangeTitleInputDialog: false })
  }
  changeTitle = (event) => {
    this.setState({ title: event.target.value });
  }
  onTitleSubmitButtonClicked = async () => {
    const { title, selectedVideo, myVideos } = this.state

    if (title.length === 0) {
		return alert(i18n.t("examineshopdialog.placeholder.title"));
    }
    
    const { result } = await ShortsApis.PatchShorts(TokenHelper.GetToken(), {
      shortsId: selectedVideo._id,
      name: title
    })
    if (!result) {
        alert(i18n.t("onebtndialog.failEditVideo.dialogBodyText2"));
        return;
    }
    
    if (myVideos) {
      for (let i = 0; i < myVideos.length; i++) {
        if (myVideos[i]._id === selectedVideo._id) {
          myVideos[i].name = title
          break
        }
      }
      this.setState({ myVideos, isChangeTitleInputDialog: false, videoId: "", title: "" });
    }
  }
  // 공유 버튼 클릭시 활성화 되는 팝업창
  handleClickShareIcon = (video) => {
    this.setState({ isShareDialogOpen: true, selectedVideo: video })
  }
  //공유 팝업창 끄는 함수
  closeShareDialog = () => {
    this.setState({ isShareDialogOpen: false })
  }

  clickShareItem = async method => {
    alert("clickShareItem (처리 필요)")
    // const item = this.state.selectedVideo
    // if (item.state === 'Empty' || item.state === 'Rendering' || item.state === 'Waiting') return
    // try {
    //   const response = await axios.get(`${GetBaseUrl()}/api/video/share-link?id=${item._id}`)
    //   if (response && response.data && response.data.result === 'success') {
    //     const { shareId } = response.data
    //     const shareLink = window.location.origin + `/share?id=${shareId}`
    //     const { invokeCSharpAction } = window
    //     const isXamarin = invokeCSharpAction

    //     switch (method) {
    //       case 'twitter':
    //       case 'facebook':
    //         let targetLink = 'about:blank'

    //         if (method === 'twitter') targetLink = 'https://twitter.com/intent/tweet?url=' + shareLink
    //         else if (method === 'facebook') targetLink = 'https://www.facebook.com/sharer/sharer.php?u=' + shareLink

    //         if (isXamarin) window.location.href = targetLink
    //         else {
    //           const windowRef = window.open(targetLink, '_blank')
    //           if (!windowRef) this.setState({
    //             isBtnDialogOpened: true,
    //             dialogType: "shareLinkBlock"
    //           })
    //         }
    //         break

    //       case 'linkxamarin':
    //         window.invokeCSharpAction(`method=linkshare&url=${shareLink}`)
    //         break

    //       case 'link':
    //       default:
    //         CopyToClipboard(shareLink)
    //         this.setState({
    //           isBtnDialogOpened: true,
    //           dialogType: "shareSuccess"
    //         })
    //         break
    //     }
    //   }
    // }
    // catch (e) {
    //   this.setState({
    //     isBtnDialogOpened: true,
    //     dialogType: "shareFail"
    //   })
    // }
  }

  handlePayDialogOpen = () => this.setState({ isOpenPayTwoButton: true })
  handleClosePayDialog = () => this.setState({ isOpenPayTwoButton: false })
  handleClickPay = () => this.props.history.push('/payment')

  getVideoThumbnailImage = video => {
    if (video.thumbnailURL) {
      // 임시처리 > 1시간마다 썸네일 업데이트
      return video.thumbnailURL + `?date=${new Date().toISOString().substring(0, 13)}`
    }
    return ""
  }

  render() {
    const Waiting = {
      state: "Waiting",
      iconUrl: "https://front.videomonster.com/images-u6yd72dy/web/myvideo/waiting.png",
      text: i18n.t("myvideo.waiting.text"),
      textBackgroundColor: "none",
      confirmationDialog: {
        title: i18n.t("myvideo.waiting.title"),
        message:
          i18n.t("myvideo.waiting.message")
      }
    };
    const Rendering = {
      state: "Rendering",
      iconUrl: "",
      text: i18n.t("myvideo.rendering.text"),
      textBackgroundColor: "none",
      confirmationDialog: {
        title: i18n.t("myvideo.rendering.title"),
        message:
          i18n.t("myvideo.rendering.message")
      }
    };

    const Finish = {
      state: "Finish",
      iconUrl: FinishedLayerIcon,
      text: i18n.t("myvideo.finish.text"),
      textBackgroundColor: "none",
      confirmationDialog: {
        title: i18n.t("myvideo.finish.title"),
        message:
          i18n.t("myvideo.finish.message")
      }
    }

    const Empty = {
      state: "Empty",
      iconUrl: EmptyLayerIcon,
      text: i18n.t("myvideo.empty.text"),
      textBackgroundColor: "none",
      confirmationDialog: {
        title: i18n.t("myvideo.empty.title"),
        message:
          i18n.t("myvideo.empty.message")
      }
    }

    const ErrorState = {
      state: "Error",
      iconUrl: '',
      text: i18n.t("myvideo.error.text"),
      textBackgroundColor: "none",
      confirmationDialog: {
        title: i18n.t("myvideo.error.title"),
        message:
          i18n.t("myvideo.error.message1_1") +
          i18n.t("myvideo.error.message1_2") +
          i18n.t("myvideo.error.message1_3")
      }
    }

    const renderStateTable = {
      Empty,
      Waiting,
      Rendering,
      Finish,
      Error: ErrorState
    };
    const { myVideos, isOpenPayTwoButton, totalVideos } = this.state;
    let { currentPage, cardsPerPage } = this.state;

    if (myVideos) {
      let maxPageCount = Math.floor((totalVideos - 1) / cardsPerPage)
      if (maxPageCount < 0) maxPageCount = 0
      if (currentPage > maxPageCount) currentPage = maxPageCount
    }

    if (myVideos === undefined) {
      return <Loading />;
    }

    const selectedVideo = myVideos.filter(
      video => video._id === this.state.selectedVideoId
    )[0];
    const renderStateTableData = selectedVideo
      ? renderStateTable[selectedVideo.state]
      : undefined

    const confirmationDialogDatas = renderStateTableData
      ? renderStateTable[selectedVideo.state].confirmationDialog
      : undefined;

    const { paymentMode, currentUser, pointTicket } = this.props
    const isExistPayment = paymentMode || pointTicket || (currentUser && currentUser.admin);
    const isProviderCafe24 = DataManager.IsProvider(DataManager.PROVIDER.CAFE24);
    return (
      <>
        {this.props.value === "en" ?
          <VideoCount>{myVideos.length} {i18n.t("myvideo.text.video2")}</VideoCount>
          :
          <VideoCount>{i18n.t("myvideo.text.video1")} {myVideos.length} {i18n.t("myvideo.text.video2")}</VideoCount>
        }

        <div style={{ maxWidth: "1200px", margin: "auto", minHeight: "351px" }}>
          {
            myVideos.length === 0 ? (
              <EmptyVideo
                onViewAllFreeVideosButtonClicked={this.onViewAllFreeVideosButtonClicked}
                text1={i18n.t("myvideo.emptyshorts.text1")}
                text2={i18n.t("myvideo.emptyshorts.text2")}
                btntext={i18n.t("myvideo.emptyshorts.btn")}
                btn={true}
              >
              </EmptyVideo>
            ) : (
              <GridContainer>
                {myVideos
                  .map(video => {
                    const layered = renderStateTable[video.state]
                      ? renderStateTable[video.state]
                      : renderStateTable['Empty'];
                    const date = formatDate(new Date(video.createdDate));
                    const isStoreExpired = Validator.Boolean(video.isStoreExpired) ? video.isStoreExpired : true
                    return (
                      <ShortsCard
                        myvideo
                        isProviderCafe24={isProviderCafe24}
                        video={video}
                        key={video._id}
                        title={
                          video.name === ""
                            ? video.template && video.template.name
                            : video.name
                        }
                        progress={this.state.renderingVideos && this.state.renderingVideos[video._id]}
                        date={date || ""}
                        thumbnailUrl={this.getVideoThumbnailImage(video)}
                        onThumbnailClicked={this.onThumbnailClicked(
                          video._id,
                          video.analysisId,
                          video.analysisIndex,
                          layered,
                          video.isEditable,
                          isStoreExpired
                        )}
                        onChangeTitle={this.handleChangeTitle}
                        layered={layered}
                        paymentInfo={video.paymentInfo}
                        isExistPayment={isExistPayment}
                        footerComponent={
                          <ShortsCardFooter
                            video={video}
                            layered={layered}
                            onVideoEditClicked={this.onVideoEditClicked(
                              video._id,
                              video.analysisId,
                              video.analysisIndex,
                              layered,
                              video.isEditable,
                              isStoreExpired
                            )}
                            onDownloadClicked={(videoId, videoName, isDownloadable) => this.onDownloadClicked(videoId, videoName, isDownloadable, layered)}
                            onDeleteClicked={this.openDialog(
                              "ConfirmationDialog",
                              video._id,
                              layered
                            )}
                          />
                        }
                      />
                    );
                  })}
              </GridContainer>
            )
          }
        </div>

        <ShortsDialog
          provider={this.provider}
          closeDialog={this.closeDialog}
          isDialogOpened={
            this.state.isDialogOpened &&
            this.state.focusedDialogName === "ShortsDialog"
          }
          thumbnailUrl={selectedVideo ? this.getVideoThumbnailImage(selectedVideo) : undefined}
          selectedVideo={selectedVideo}
          renderStateTableData={renderStateTableData}
          onVideoEditClicked={this._onVideoEditClicked}
          onDownloadClicked={this.onDownloadClicked}
          onChangeTitle={this.handleChangeTitle}
          //onShare={this.handleClickShareIcon}
          openDialog={this.openDialog}
          value={this.props.value}
        />
        <ConfirmationDialog
          cancleText={i18n.t("global.cancel")}
          deleteText={i18n.t("global.delete")}
          closeDialog={this.closeDialog}
          isDialogOpened={
            this.state.isDialogOpened &&
            this.state.focusedDialogName === "ConfirmationDialog"
          }
          selectedVideoId={this.state.selectedVideoId}
          onDeleteClicked={this.onDeleteClicked}
          title={
            confirmationDialogDatas
              ? confirmationDialogDatas.title
              : i18n.t("myvideo.ask.delete.video.title")
          }
          message={
            confirmationDialogDatas
              ? confirmationDialogDatas.message
              : i18n.t("myvideo.ask.delete.video.text")
          }
        />
        <PaginationContainer>
          <Pagination2
            currentPage={currentPage}
            cardsPerPage={cardsPerPage}
            itemCount={totalVideos}
            onPageNumberClicked={this.onPageNumberClicked}
            onPreviousPageClicked={this.onPreviousPageClicked}
            onNextPageClicked={this.onNextPageClicked}
          />
        </PaginationContainer>

        {/* props를 부모로부터 내려받기 때문에 onebtndialog 컴포넌트에 넣지 않음 */}
        <UploadCompleted
          DesignedButtonText={i18n.t("global.confirm")}
          dialogBodyText1={i18n.t("myvideo.delete.video.confirm.title")}
          dialogHeadText={i18n.t("global.success")}
          open={this.state.userRemoveTemplate}
          closeUploadCompletedDialog={this.clickRemoveTemplate}
          closeBtn={this.clickRemoveTemplate}
        />

        <OneBtnDialog
          dialogType={this.state.dialogType}
          open={this.state.isBtnDialogOpened}
          closeBtn={this.popupHandleCloseBtn}
          onButtonClick={this.popupHandleCloseBtn}
        />
        <ChangeTitleInput
          open={this.state.isChangeTitleInputDialog}
          onClose={this.closeChangeTitleInputDialog}
          onTitleSubmitButtonCancel={this.closeChangeTitleInputDialog}
          onChange={this.changeTitle}
          onTitleSubmitButtonClicked={this.onTitleSubmitButtonClicked}
          video={this.state.selectedVideo}
        />
        <ShareDialog
          open={this.state.isShareDialogOpen}
          onClose={this.closeShareDialog}
          onShare={this.clickShareItem}
        />

        <TwoBtnDialog header={<Trans i18nKey={"myvideo.pay.dialog"} components={{ br: <br /> }} />} open={isOpenPayTwoButton} onClose={this.handleClosePayDialog} onClick={this.handleClickPay} confirmBtnLabel={i18n.t("myvideo.pay.dialog.button")} isFlexConfirmBtn>
          <div>{i18n.t("myvideo.pay.dialog.text")}</div>
        </TwoBtnDialog>
        <Uploading open={this.state.isUploading} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  paymentMode: state.paymentModeStore.paymentMode,
  pointTicket: state.pointTicketStore.pointTicket,
  accountStatus: state.accountStatusStore.accountStatus,
  uploadImgBloburl: state.uploadImgBloburlStore.uploadImgBloburl,
  coupons: state.couponStore.coupons
})

export default connect(mapStateToProps, null)(ShortsPage)